export const LOADING_STEP_TITLE = 'Generating frames...';
export const LOADING_STEP_TEXT_IMAGE =
  'Your asset will be ready in 1 minute. Feel free to close the app and return later.';
export const LOADING_STEP_TEXT_VIDEO =
  'Your asset will be ready in 5 minutes. Feel free to close the app and return later.';

// Inline loading card constants (for "My Creations" tab)
// Uses full text with close-app message per design requirements
export const LOADING_CARD_TITLE = 'Generating frames...';
export const LOADING_CARD_TEXT_IMAGE =
  'Your asset will be ready in 1 minute. Feel free to close the app and return later.';
export const LOADING_CARD_TEXT_VIDEO =
  'Your asset will be ready in 5 minutes. Feel free to close the app and return later.';

export const ONBOARDING_WELCOME_TITLE = 'What do you want to make?';
export const ONBOARDING_WELCOME_DESCRIPTION =
  "Swipe through a few looks. We'll put the ones you like first, so you're not scrolling past hundreds of effects to find yours.";
export const ONBOARDING_START_BUTTON = 'Get started';
export const ONBOARDING_DECLINE_BUTTON = 'Not now';
export const ONBOARDING_SKIP_LABEL = 'Skip';
export const ONBOARDING_SKIP_DECK = 'Skip';
export const ONBOARDING_LIKE_LABEL = 'Like';
export const ONBOARDING_PICK_TITLE = 'Which of these do you like?';
export const ONBOARDING_PICK_DESCRIPTION = 'Swipe right to like, left to skip.';
export const ONBOARDING_PROGRESS = '{{current}} of {{total}}';
export const ONBOARDING_LIKED_COUNT = '{{count}} liked';
